/* Custom-Song Funnel — storefront logic (theme asset).
 *
 * Multi-step quiz -> live personalized lyric preview (song-API) -> style samples
 * -> NATIVE Shopify <product-form> add-to-cart (theme cart drawer).
 *
 * Progress bars are painted as a background gradient on a zero-width-space
 * element: the theme's base.css hides `div:empty` (display:none), so an empty
 * fill div disappears — we paint the track itself instead.
 */
(function () {
  "use strict";

  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  var fmtTime = function (s) { if (!isFinite(s)) return "0:00"; var m = Math.floor(s / 60), ss = Math.floor(s % 60); return m + ":" + (ss < 10 ? "0" : "") + ss; };
  var NOTE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18V5l11-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/></svg>';
  // Paint 0..pct of the track with the foreground colour; rail shows through the rest.
  function paintBar(el, pct) {
    if (!el) return;
    var fg = el._fg || (el._fg = getComputedStyle(el).color);
    el.style.backgroundImage = "linear-gradient(to right, " + fg + " " + pct + "%, transparent " + pct + "%)";
  }

  var STEPS = [
    { type: "choice", key: "relationship", eyebrow: "Let's start with the basics", q: "Who's this song for?", options: ["My wife", "My husband", "My girlfriend", "My boyfriend", "My partner", "My mom", "My dad", "My best friend", "Someone else"] },
    { type: "text", key: "recipientName", q: "What's their name?", placeholder: "Enter their first name", help: "Tip: add pronunciation for clarity (e.g. Alicia: ah-lee-sha)", required: true },
    { type: "choice", key: "occasion", q: "What's the occasion?", options: ["Anniversary", "Valentine's Day", "Wedding", "Birthday", "Just because", "In memory"] },
    { type: "choice", key: "genre", q: "Choose a style.", options: ["R&B", "Acoustic Pop", "Soul", "Country", "Pop Ballad"] },
    { type: "choice", key: "singer", q: "Whose voice sings it?", help: "We recommend a voice that fits your story.", options: ["A female voice", "A male voice"] },
    { type: "textarea", key: "loveAbout", q: "What makes them special?", help: "Describe their character and the qualities you love most.", placeholder: "The way they…", required: true },
    { type: "textarea", key: "story", q: "Share your favorite memories.", help: "The moments with them you treasure most.", placeholder: "The first time we met was…", required: true },
    { type: "textarea", key: "message", q: "A message from your heart.", help: "Anything else you'd like woven into the song — optional.", placeholder: "Happy anniversary, my love…" },
    { type: "contact", key: "contact", q: "Almost there!", help: "Where should we send your song?" },
    { type: "crafting" },
    { type: "reveal" }
  ];
  var QUESTION_COUNT = STEPS.filter(function (s) { return s.key; }).length;

  function initFunnel(configEl) {
    var root = configEl.closest("[data-cs-root]") || configEl.closest("section") || configEl.parentNode;
    var mount = root.querySelector("[data-cs-mount]");
    var hdrBar = root.querySelector("[data-cs-progress]");
    var hdrPct = root.querySelector("[data-cs-pct]");
    var hdrTitle = root.querySelector("[data-cs-title]");
    var pagehead = root.querySelector("[data-cs-pagehead]");
    var landing = root.querySelector("[data-cs-landing]");
    var quiz = root.querySelector("[data-cs-quiz]");
    var cfg; try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
    cfg.proof = Array.isArray(cfg.proof) ? cfg.proof : [];
    cfg.samples = Array.isArray(cfg.samples) ? cfg.samples.filter(function (s) { return s && s.audio; }) : [];

    var answers = {}, index = 0, preview = null, tier = "standard", started = false;

    function setHeader(pct, title) {
      pct = Math.max(0, Math.min(100, Math.round(pct)));
      if (hdrPct) hdrPct.textContent = pct + "%";
      paintBar(hdrBar, pct);
      if (title && hdrTitle) hdrTitle.textContent = title;
    }
    function quizPct() { return (STEPS.slice(0, index).filter(function (s) { return s.key; }).length / QUESTION_COUNT) * 100; }
    function go(next) { index = next; render(); }

    function render() {
      var step = STEPS[index];
      // The page header (title + bar) is the quiz progress indicator; hide it at
      // crafting/reveal so it doesn't duplicate the crafting screen's own bar.
      var hideHead = step.type === "crafting" || step.type === "reveal";
      if (pagehead) pagehead.style.display = hideHead ? "none" : "";
      if (!hideHead) setHeader(quizPct(), "Customize Your Song");
      mount.innerHTML = "";
      var el = step.type === "choice" ? renderChoice(step) :
        step.type === "contact" ? renderContact(step) :
        step.type === "crafting" ? renderCrafting() : step.type === "reveal" ? renderReveal() : renderInput(step);
      el.classList.add("cs-step");
      mount.appendChild(el);
      quiz.scrollTop = 0;
    }

    function _unusedIntro() {
      var d = document.createElement("div");
      d.innerHTML = '<p class="cs-eyebrow2">One of a kind</p><h2 class="cs-q">' + esc(cfg.heading) + "</h2>" +
        '<p class="cs-help">Answer a few questions and we\'ll write you a personalized preview — on the spot — before you decide.</p>' +
        '<div class="cs-nav"><span></span><button class="cs-btn" data-next>Start</button></div>';
      d.querySelector("[data-next]").addEventListener("click", function () { go(1); });
      return d;
    }

    function renderInput(step) {
      var d = document.createElement("div");
      var tag = step.type === "textarea" ? "textarea" : "input";
      d.innerHTML = (step.eyebrow ? '<p class="cs-eyebrow2">' + esc(step.eyebrow) + "</p>" : "") +
        '<h2 class="cs-q">' + esc(step.q) + "</h2>" +
        "<" + tag + ' class="cs-' + (step.type === "textarea" ? "textarea" : "input") + '" data-field placeholder="' + esc(step.placeholder || "") + '"' +
        (step.type === "textarea" ? "></textarea>" : "/>") +
        (step.help ? '<p class="cs-help">' + esc(step.help) + "</p>" : "") +
        '<div class="cs-nav"><button class="cs-link" data-back>Back</button><button class="cs-btn" data-next disabled>Continue</button></div>';
      var field = d.querySelector("[data-field]");
      field.value = answers[step.key] || "";
      var next = d.querySelector("[data-next]");
      function validate() { next.disabled = step.required ? field.value.trim().length === 0 : false; } // no character minimum
      field.addEventListener("input", validate); validate(); field.focus();
      next.addEventListener("click", function () { answers[step.key] = field.value.trim(); go(index + 1); });
      d.querySelector("[data-back]").addEventListener("click", function () { answers[step.key] = field.value.trim(); go(index - 1); });
      return d;
    }

    function renderContact(step) {
      var d = document.createElement("div");
      d.innerHTML = '<p class="cs-eyebrow2">Complete your song</p><h2 class="cs-q">' + esc(step.q) + "</h2>" +
        (step.help ? '<p class="cs-help" style="margin:0 0 1.6rem">' + esc(step.help) + "</p>" : "") +
        '<label class="cs-flabel">Your email address</label>' +
        '<input class="cs-input" type="email" data-email placeholder="you@email.com" value="' + esc(answers.email || "") + '" autocomplete="email"/>' +
        '<label class="cs-flabel" style="margin-top:1.6rem">Your phone number <span class="cs-opt">(optional)</span></label>' +
        '<input class="cs-input" type="tel" data-phone placeholder="(555) 123-4567" value="' + esc(answers.phone || "") + '" autocomplete="tel"/>' +
        '<div class="cs-nav"><button class="cs-link" data-back>Back</button><button class="cs-btn" data-next disabled>Continue</button></div>';
      var email = d.querySelector("[data-email]"), phone = d.querySelector("[data-phone]"), next = d.querySelector("[data-next]");
      function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); }
      function validate() { next.disabled = !validEmail(email.value); }
      email.addEventListener("input", validate); phone.addEventListener("input", validate); validate(); email.focus();
      function save() { answers.email = email.value.trim(); answers.phone = phone.value.trim(); }
      next.addEventListener("click", function () { if (!validEmail(email.value)) return; save(); go(index + 1); });
      d.querySelector("[data-back]").addEventListener("click", function () { save(); go(index - 1); });
      return d;
    }

    function renderChoice(step) {
      var d = document.createElement("div");
      d.innerHTML = (step.eyebrow ? '<p class="cs-eyebrow2">' + esc(step.eyebrow) + "</p>" : "") +
        '<h2 class="cs-q">' + esc(step.q) + "</h2><div class=\"cs-choices\">" +
        step.options.map(function (o) { return '<button class="cs-choice' + (answers[step.key] === o ? " is-selected" : "") + '" data-opt="' + esc(o) + '"><span>' + esc(o) + "</span></button>"; }).join("") +
        '</div><div class="cs-nav"><button class="cs-link" data-back>Back</button><span></span></div>';
      d.querySelectorAll("[data-opt]").forEach(function (b) { b.addEventListener("click", function () { answers[step.key] = b.getAttribute("data-opt"); go(index + 1); }); });
      d.querySelector("[data-back]").addEventListener("click", function () { go(index - 1); });
      return d;
    }

    function renderCrafting() {
      var d = document.createElement("div");
      d.className = "cs-craft";
      d.innerHTML = '<div class="cs-orb"></div><h2 class="cs-q">Crafting ' + esc(answers.recipientName || "their") + "'s lyrics…</h2>" +
        '<p class="cs-craftpct" data-cpct>0%</p><div class="cs-craftbar" data-cbar>​</div>' +
        '<p class="cs-craft__status" data-status>Reading your story…</p>' +
        (cfg.proof.length ? '<div class="cs-craft__proof">' + cfg.proof.map(function (p, i) {
          return '<figure class="cs-proofcard' + (i === 0 ? " is-active" : "") + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : "") + "<figcaption>" + esc(p.text) + "</figcaption></figure>";
        }).join("") + "</div>" : "") +
        '<div class="cs-error cs-hidden" data-err></div>';

      var cbar = d.querySelector("[data-cbar]"), cpct = d.querySelector("[data-cpct]");
      var STATUS = ["Reading your story…", "Finding the melody…", "Choosing the right words…", "Shaping the verse…", "Writing your chorus…", "Almost there…"];
      var statusEl = d.querySelector("[data-status]"), cards = [].slice.call(d.querySelectorAll(".cs-proofcard"));
      var si = 0, pi = 0, start = Date.now(), CM = cfg.craftMs || 60000;
      var tick = setInterval(function () {
        var p = Math.min(100, ((Date.now() - start) / CM) * 100);
        cpct.textContent = Math.round(p) + "%"; paintBar(cbar, p);
      }, 100);
      var rotate = setInterval(function () {
        si = (si + 1) % STATUS.length; statusEl.textContent = STATUS[si];
        if (cards.length) { cards[pi].classList.remove("is-active"); pi = (pi + 1) % cards.length; cards[pi].classList.add("is-active"); }
      }, 3200);

      var timerDone = false, fetchDone = false, failed = false;
      function done() { if (fetchDone && timerDone && !failed) { clearInterval(tick); clearInterval(rotate); go(STEPS.length - 1); } }
      setTimeout(function () { timerDone = true; done(); }, CM);
      fetchPreview().then(function (data) { preview = data; fetchDone = true; done(); }).catch(function () {
        failed = true; clearInterval(tick); clearInterval(rotate);
        // Always generic — never surface raw backend/API error text to the customer.
        var e = d.querySelector("[data-err]"); e.textContent = "We couldn't finish your preview just now. Please try again."; e.classList.remove("cs-hidden");
        statusEl.innerHTML = '<button class="cs-btn cs-btn--ghost" data-retry>Try again</button>';
        d.querySelector("[data-retry]").addEventListener("click", function () { go(index); });
      });
      return d;
    }

    function renderReveal() {
      var d = document.createElement("div");
      var name = answers.recipientName || "them";
      var samples = pickSamples(answers.genre, cfg.samples);
      d.innerHTML = '<p class="cs-eyebrow2">Your preview</p><h2 class="cs-q">Here\'s the start of ' + esc(name) + "'s song</h2>" +
        '<div class="cs-lyrics">' + esc((preview && preview.verse) || "") + '</div><div class="cs-flourish">✦ ✦ ✦</div>' +
        '<div class="cs-lyrics">' + esc((preview && preview.chorus) || "") + "</div>" +
        '<div class="cs-locked"><div class="cs-locked__lines"><span></span><span></span><span></span></div>' +
        '<p class="cs-locked__label"><strong>This is just the opening.</strong> Your full song — more verses, a personalized bridge, and studio-recorded vocals — is written and produced after you order, delivered in 72 hours.</p></div>' +
        (samples.length ? '<h3 class="cs-subhead">Hear the quality others got</h3><div class="cs-samples">' + samples.map(sampleHtml).join("") + "</div>" : "") +
        '<div class="cs-buy"><div class="cs-tiers">' + tierHtml("standard", "Standard", cfg.delivery.standard, cfg.prices.standard) + tierHtml("express", "Express", cfg.delivery.express, cfg.prices.express) + "</div>" +
          '<product-form>' +
            '<form action="' + esc(cfg.cartAddUrl || "/cart/add") + '" method="post" enctype="multipart/form-data" novalidate>' +
              '<input type="hidden" name="id" value="' + esc(cfg.variants.standard) + '" data-variant>' +
              '<input type="hidden" name="properties[Song for]" value="' + esc(answers.recipientName || "") + '">' +
              '<input type="hidden" name="properties[From]" value="' + esc(answers.relationship || "") + '">' +
              '<input type="hidden" name="properties[Occasion]" value="' + esc(answers.occasion || "") + '">' +
              '<input type="hidden" name="properties[Style]" value="' + esc(answers.genre || "") + '">' +
              '<input type="hidden" name="properties[Voice]" value="' + esc(answers.singer || "") + '">' +
              '<input type="hidden" name="properties[Email]" value="' + esc(answers.email || "") + '">' +
              '<input type="hidden" name="properties[Phone]" value="' + esc(answers.phone || "") + '">' +
              '<input type="hidden" name="properties[Brief ID]" value="' + esc((preview && preview.briefId) || "") + '">' +
              '<button type="submit" name="add" class="cs-atc"><span data-atc-label>Add to Cart — ' + esc(cfg.prices.standard) + "</span>" +
                '<div class="loading-overlay__spinner hidden"><svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>' +
              "</button>" +
            "</form>" +
          "</product-form></div>";

      wireSamples(d);
      var variantInput = d.querySelector("[data-variant]"), label = d.querySelector("[data-atc-label]");
      d.querySelectorAll("[data-tier]").forEach(function (el) {
        el.addEventListener("click", function () {
          tier = el.getAttribute("data-tier");
          d.querySelectorAll("[data-tier]").forEach(function (x) { x.classList.toggle("is-selected", x === el); });
          variantInput.value = cfg.variants[tier]; label.textContent = "Add to Cart — " + cfg.prices[tier];
        });
      });
      // Fire a Meta AddToCart on submit — the theme's page pixels don't track Ajax cart adds on their own.
      var pform = d.querySelector("product-form form");
      if (pform) pform.addEventListener("submit", function () {
        if (typeof window.fbq === "function") {
          var val = parseFloat(String(cfg.prices[tier]).replace(/[^0-9.]/g, "")) || 0;
          window.fbq("track", "AddToCart", { content_type: "product", content_ids: [String(cfg.variants[tier])], value: val, currency: "USD" });
        }
      });
      return d;
    }

    function tierHtml(key, label, delivery, price) {
      return '<button type="button" class="cs-tier' + (key === tier ? " is-selected" : "") + '" data-tier="' + key + '">' +
        '<span class="cs-tier__top"><span>' + esc(label) + "</span><span>" + esc(price) + '</span></span><span class="cs-tier__sub">' + esc(delivery) + "</span></button>";
    }

    function sampleHtml(s, i) {
      return '<div class="cs-sample" data-sample="' + i + '"><div class="cs-sample__art">' + NOTE_SVG + "</div>" +
        '<div class="cs-sample__body"><div class="cs-sample__meta"><span class="cs-sample__title">' + esc(s.title) + '</span><span class="cs-sample__note">' + esc(s.note) + "</span></div>" +
        '<div class="cs-seek" data-seek>​</div><div class="cs-sample__time"><span data-cur>0:00</span><span data-dur>0:00</span></div></div>' +
        '<button class="cs-sample__play" data-play aria-label="Play">▶</button>' +
        '<audio preload="none" src="' + esc(s.audio) + '"></audio></div>';
    }

    function wireSamples(scope) {
      scope.querySelectorAll("[data-sample]").forEach(function (wrap) {
        var audio = wrap.querySelector("audio"), play = wrap.querySelector("[data-play]"), seek = wrap.querySelector("[data-seek]");
        var cur = wrap.querySelector("[data-cur]"), dur = wrap.querySelector("[data-dur]");
        play.addEventListener("click", function () {
          scope.querySelectorAll("audio").forEach(function (a) { if (a !== audio) a.pause(); });
          scope.querySelectorAll("[data-play]").forEach(function (b) { if (b !== play) b.textContent = "▶"; });
          if (audio.paused) { audio.play(); play.textContent = "❚❚"; } else { audio.pause(); play.textContent = "▶"; }
        });
        audio.addEventListener("loadedmetadata", function () { dur.textContent = fmtTime(audio.duration); });
        audio.addEventListener("timeupdate", function () { paintBar(seek, audio.duration ? (audio.currentTime / audio.duration) * 100 : 0); cur.textContent = fmtTime(audio.currentTime); });
        audio.addEventListener("ended", function () { play.textContent = "▶"; paintBar(seek, 0); });
        seek.addEventListener("click", function (e) { var r = seek.getBoundingClientRect(); if (audio.duration) audio.currentTime = ((e.clientX - r.left) / r.width) * audio.duration; });
      });
    }

    function fetchPreview() {
      if (!cfg.apiBase) return Promise.reject(new Error("Song API is not configured."));
      return fetch(cfg.apiBase.replace(/\/$/, "") + "/api/preview-lyrics", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ recipientName: answers.recipientName, relationship: answers.relationship, occasion: answers.occasion, story: answers.story, loveAbout: answers.loveAbout, message: answers.message, tone: answers.tone, genre: answers.genre, singer: answers.singer, email: answers.email, phone: answers.phone })
      }).then(function (r) { return r.json().then(function (b) { if (!r.ok) throw new Error(b.error || "Preview failed."); return b; }); });
    }

    // Landing → full-page quiz.
    function openQuiz() {
      quiz.classList.add("is-open");
      document.documentElement.style.overflow = "hidden";
      if (!started) { started = true; index = 0; render(); }
    }
    function closeQuiz() { quiz.classList.remove("is-open"); document.documentElement.style.overflow = ""; }
    root.querySelectorAll("[data-cs-start]").forEach(function (b) { b.addEventListener("click", openQuiz); });
    var closeBtn = root.querySelector("[data-cs-close]");
    if (closeBtn) closeBtn.addEventListener("click", closeQuiz);

    // Landing "hear real examples" — a few real sample songs, wired with the seek player.
    var lsWrap = root.querySelector("[data-cs-landing-samples]");
    if (lsWrap) {
      var picks = cfg.samples.slice(0, 3);
      lsWrap.innerHTML = picks.map(sampleHtml).join("");
      wireSamples(lsWrap);
    }
    // Hero example player — plays the first real sample with an animated waveform.
    var hp = root.querySelector("[data-cs-hplayer]");
    if (hp && cfg.samples.length) {
      var s0 = cfg.samples[0];
      var hAudio = hp.querySelector("[data-h-audio]"), hPlay = hp.querySelector("[data-h-play]");
      var hWave = hp.querySelector("[data-h-wave]"), hTitle = hp.querySelector("[data-h-title]"), hNote = hp.querySelector("[data-h-note]");
      hAudio.src = s0.audio;
      hTitle.childNodes[0].nodeValue = s0.title + " ";
      hNote.textContent = s0.note || "Tap play";
      var BARS = 36, heights = [];
      for (var i = 0; i < BARS; i++) { var h = 20 + Math.round(Math.abs(Math.sin(i * 1.3)) * 60 + Math.random() * 20); heights.push(h); hWave.insertAdjacentHTML("beforeend", '<i style="height:' + h + '%"></i>'); }
      var bars = hWave.querySelectorAll("i");
      hPlay.addEventListener("click", function () {
        if (hAudio.paused) { hAudio.play(); hPlay.textContent = "❚❚"; } else { hAudio.pause(); hPlay.textContent = "▶"; }
      });
      hAudio.addEventListener("timeupdate", function () {
        var p = hAudio.duration ? hAudio.currentTime / hAudio.duration : 0, lit = Math.round(p * BARS);
        bars.forEach(function (b, i) { b.classList.toggle("on", i < lit); });
      });
      hAudio.addEventListener("ended", function () { hPlay.textContent = "▶"; bars.forEach(function (b) { b.classList.remove("on"); }); });
      hWave.addEventListener("click", function (e) { var r = hWave.getBoundingClientRect(); if (hAudio.duration) hAudio.currentTime = ((e.clientX - r.left) / r.width) * hAudio.duration; });
    }

    // "Listen to an example" → play the hero example.
    var exBtn = root.querySelector("[data-cs-example]");
    if (exBtn && hp) exBtn.addEventListener("click", function () { var b = hp.querySelector("[data-h-play]"); if (b) b.click(); });
  }

  function pickSamples(genre, samples) {
    samples = Array.isArray(samples) ? samples.filter(function (s) { return s && s.audio; }) : [];
    if (!samples.length) return [];
    var g = String(genre || "").toLowerCase();
    var matched = samples.filter(function (s) { return g && String(s.genre || "").toLowerCase().indexOf(g) !== -1; });
    return (matched.length ? matched : samples).slice(0, 4);
  }

  function boot() { document.querySelectorAll("[data-cs-config]").forEach(initFunnel); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
